<script>
import { defineComponent } from 'vue'
import CardSections from "./Shared/CardSections.vue";
import FormError from "../../Shared/FormError.vue";
import TextInput from "../../Shared/TextInput.vue";

export default defineComponent({
    name: "TwoFactorAuthenticationDisable",
    components: { TextInput, FormError, CardSections },
    props: {
        errors: Object,
    },
    data() {
        return {
            form: this.$inertia.form({
                'code': null,
            }),
            translationPrefix: 'employerdashboard::pages/settings/two-factor-authentication.',
        }
    },
    methods: {
        getTranslation(path) {
            return this.Lang.get(this.translationPrefix + path)
        },
        submit() {
            this.form.post(
                route(
                    'nl.employerdashboard.settings.two-factor-authentication.disable.post',
                    { company_as_uuid: this.$page.props.auth.user.selected_company.uuid }
                ),
            );
        },
    },
})
</script>

<template>
    <card-sections
        :title="getTranslation('title')"
        :subtitle="getTranslation('subtitle')"
        tabName="two-factor-authentication"
        :hideMsg="true"
    >
        <p class="font-poppins font-weight-light color-dark-blue">
            {{ getTranslation('disable.information') }}
        </p>

        <form @submit.prevent="submit" class="mt-3">
            <text-input
                id="code"
                v-model="form.code"
                :placeholder="Lang.get('employerdashboard::shared.placeholder.2fa_code')"
                :label="getTranslation('disable.form.code')"
                :error="errors['code']"
            />

            <div class="d-flex mt-3 ">
                <input class="btn btn-danger" type="submit" :value="getTranslation('disable.form.submit')">

                <inertia-link
                    type="button"
                    class="btn btn-outline-secondary ml-2"
                    :href="route('nl.employerdashboard.settings.two-factor-authentication.start.show', {
                        company_as_uuid: this.$page.props.auth.user.selected_company.uuid
                    })"
                >
                    {{ getTranslation('disable.form.cancel') }}
                </inertia-link>
            </div>
        </form>
    </card-sections>

</template>
